import { Software } from "src/types/software";

import { ssoApi } from "..";
import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";


const softwareApi = ssoApi.enhanceEndpoints({ addTagTypes: [CacheKeys.SOFTWARE] }).injectEndpoints({
    endpoints: builder => ({
        softwares: builder.query<Software[], void>({
          query: () => ({ url: `${Endpoints.PRODUCTS}` }),
          transformResponse: (response: { result: Software[] }) => response.result,
          providesTags: [CacheKeys.SOFTWARE],
        }),
      }),
    });

export const { useSoftwaresQuery } = softwareApi;

